export default __webpack_public_path__ + "static/media/stamp.6cbaa2ae.svg";